<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.name"
          :label="$t('global.name')"
          type="text"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.namefr"
          :label="$t('global.namefr')"
          type="text"
        />
      </v-col>
    </v-row>
 

    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="typeSelectItems"
          v-model="item.types"
          :items="typeSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('global.type')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="categorySelectItems"
          v-model="item.category"
          :items="categorySelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('process.category')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
          <v-col cols="12" sm="6" md="6">
          <v-radio-group v-model="item.defaultProcess" row :label="$t('process.defaultprocess')">
            <v-radio
              :label="$t('global.true')"
              value="true"
            ></v-radio>
            <v-radio
              :label="$t('global.false')"
              value="false"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-col>
      <v-col cols="12" sm="6" md="6">
          <v-col cols="12" sm="6" md="6">
          <v-radio-group v-model="item.public" row :label="$t('global.hub')">
            <v-radio
              :label="$t('global.true')"
              value="true"
            ></v-radio>
            <v-radio
              :label="$t('global.false')"
              value="false"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
          <v-radio-group v-model="item.enabled" row :label="$t('global.enabled')">
            <v-radio
              :label="$t('global.true')"
              value="true"
            ></v-radio>
            <v-radio
              :label="$t('global.false')"
              value="false"
            ></v-radio>
          </v-radio-group>
        </v-col>
    </v-row>

  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'ProcessFilter',
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
      this.typeGetSelectItems();
      this.categoryGetSelectItems();
  },

  computed: {
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    ...mapFields('processtype', {
      typeSelectItems: 'selectItems',
    }),
    ...mapFields('category', {
      categorySelectItems: 'selectItems',
    })
  },
  methods: {
    
    ...mapActions({
      typeGetSelectItems: 'processtype/fetchSelectItems',
    }),
    ...mapActions({
      categoryGetSelectItems: 'category/fetchSelectItems'
    })
    
  }
};
</script>
